module.exports = (__webpack_require__(3))(4);


//////////////////
// WEBPACK FOOTER
// delegated ./src/utilities/PluginUtils.js from dll-reference girder_plugin_large_image_annotation
// module id = 2
// module chunks = 0